import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { Observable, of, Subject } from "rxjs";
import { debounceTime, shareReplay, switchMap } from "rxjs/operators";

import { UnsubscribeOnDestroy } from "@dffedb/util";

import { AdresseSearch, ForsyningPaaAdresseResult } from "./model/forsyning-paa-adresse.model";
import { ForsyningPaaAdresseViewModel } from "./model/forsyning-paa-adresse.view-model";
import { ForsyningPaaAdresseSandbox } from "./services/forsyning-paa-adresse.sandbox";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from "@angular/material/autocomplete";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "forsyning-paa-adresse",
    templateUrl: "./forsyning-paa-adresse.component.html",
    styleUrls: ["./forsyning-paa-adresse.component.scss"],
    providers: [ForsyningPaaAdresseSandbox],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class ForsyningPaaAdresseComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input() public nodeId: number;
    @Output() public lookup = new EventEmitter<ForsyningPaaAdresseResult>();

    public adresser$: Observable<AdresseSearch[]> = of([]);
    private aktuelAdresseSubject: Subject<AdresseSearch> = new Subject<AdresseSearch>();
    public result$: Observable<ForsyningPaaAdresseResult>;
    public vm$: Observable<ForsyningPaaAdresseViewModel>;

    public formGroup = new UntypedFormGroup({
        searchValue: new UntypedFormControl("", [])
    });

    constructor(private readonly sandbox: ForsyningPaaAdresseSandbox) {
        super();
        this.adresser$ = this.formGroup.get("searchValue").valueChanges.pipe(
            debounceTime(200),
            switchMap((value) => {
                const query = typeof value === "string" ? value.trim() : "";
                return query.length >= 2 ? this.sandbox.findAdresser(query) : of([]);
            })
        );
        this.result$ = this.aktuelAdresseSubject.pipe(
            switchMap((adresse) => this.sandbox.checkOmDerLeveresPaaAdressen(adresse)),
            shareReplay(1)
        );
        this.subs.add(this.result$.subscribe((result) => this.lookup.emit(result)));
    }

    public ngOnInit(): void {
        this.vm$ = this.sandbox.selectViewModel(+this.nodeId);
        this.addCustomStylesheet();
    }

    public displayFn(value: AdresseSearch | string): string {
        if (!value) {
            return "";
        }
        return typeof value === "string" ? value : value.tekst ?? "";
    }

    public onSearchValueChange(value: AdresseSearch): void {
        if (value.type === "navngivenvejpostnummer" && value.vejnavn) {
            this.formGroup.get("searchValue")?.setValue(value.vejnavn, { emitEvent: true });
            return;
        }
        this.aktuelAdresseSubject.next(value);
    }

    public addCustomStylesheet(): void {
        if (!this.vm$) return;
        this.vm$.subscribe((vm) => {
            if (vm.konfiguration.cssLeveresFjernvarme && vm.konfiguration.cssLeveresFjernvarme !== "") {
                const style = document.createElement("style");
                style.innerHTML = vm.konfiguration.cssLeveresFjernvarme;
                document?.head.appendChild(style);
            }
        });
    }
}
